
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("c0Tkr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $80075ad1365469d0$export$2e2bcd8739ae039);

var $6uWhG = parcelRequire("6uWhG");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $4kMB4 = parcelRequire("4kMB4");

var $fcQiO = parcelRequire("fcQiO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80075ad1365469d0$export$2e2bcd8739ae039 = async ({ match: match, query: query }, _storeContext)=>{
    const projectKey = (0, $fcQiO.getProjectKeyOrIdFromMatchAndQuery)({
        match: match,
        query: query
    });
    try {
        const data = await (0, $1Ozm9.default)(`/rest/servicedesk/1/pages/agent/servicedesk/${projectKey}?operation=getProjectKeyOrIdFromMatchAndQuery`);
        (0, $6uWhG.setMark)((0, $4kMB4.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'jiraServicedeskContextResource',
                packageName: 'jiraRouterResourcesServiceDeskContext'
            },
            error: error
        });
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.router.resource.sd.servicedesk.context', 'fetchData', error);
        throw error;
    }
};

});
parcelRegister("4kMB4", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $2b841d37299dd740$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $2b841d37299dd740$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $2b841d37299dd740$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $2b841d37299dd740$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $2b841d37299dd740$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $2b841d37299dd740$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $2b841d37299dd740$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $2b841d37299dd740$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $2b841d37299dd740$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $2b841d37299dd740$export$4eb8d44ddb14424a);


var $dNyX9 = parcelRequire("dNyX9");
const $2b841d37299dd740$export$7e50945a65dd40e = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ff834eccc35b9089));
const $2b841d37299dd740$export$17cbe723d23101d8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$86b05e34d462ead8));
const $2b841d37299dd740$export$887fadb22e7c7735 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$d6a604a7d9a390fb));
const $2b841d37299dd740$export$bd099c0a906f4b3f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$3ae43cc1782d058f));
const $2b841d37299dd740$export$d23ef9e7633e30e7 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$363f6703ffa600be));
const $2b841d37299dd740$export$319da6d901948a6d = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$e87b74567b79c8));
const $2b841d37299dd740$export$f0b6622cdc5c7e4f = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$99fe642459a8b02));
const $2b841d37299dd740$export$37e82663aa1e79a8 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$ab1f5705fc8e0571));
const $2b841d37299dd740$export$21146514eacceb12 = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$8c3a9046da692c35));
const $2b841d37299dd740$export$4eb8d44ddb14424a = (0, $dNyX9.getPrefixedMarkName)((0, $2e47af044bce450a$export$5aa497d1efdcc5bf));

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("dNyX9", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $63d33e770a180de1$export$c8f0e9837e7e9425);

const $63d33e770a180de1$export$c8f0e9837e7e9425 = (name)=>`${0, $2e47af044bce450a$export$56940a9488e85199}${name}`;

});




//# sourceMappingURL=async-resource-servicedesk-context.c94978e4.js.map
